import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addItemToCart, removeItemFromCart, updateCartItemQuantity } from '../redux/actions/cartActions';
import { useNavigate } from 'react-router-dom';
import ProductList from "../components/ProductList"

export const Checkout = () => {
  const cart = useSelector((state) => state.cart.cartItems);
  const cartValue = useSelector((state) => state.cart.totalAmount);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const products = useSelector((state) => state.products.recommendedProducts);

  const handleIncreaseQuantity = (product, size) => {
    dispatch(addItemToCart({ product, size, quantity: 1 }));
  };

  const handleDecreaseQuantity = (productId, size) => {
    const existingItem = cart.find(
      (item) => item.product.id === productId && item.size === size
    );

    if (existingItem.quantity === 1) {
      if (window.confirm('Are you sure you want to remove this item from the cart?')) {
        dispatch(removeItemFromCart({ productId, size }));
      }
    } else {
      dispatch(updateCartItemQuantity({ productId, size, quantity: existingItem.quantity - 1 }));
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      {cart.length > 0 && <div className="flex flex-row items-start justify-around bg-white p-5 w-full h-auto">
        <div className="w-[2.5%]"></div>
        <div className="w-[50%] h-full flex flex-col items-start justify-start py-5">
          {cart.length === 0 ? (
            <>
              <p className="text-xl">Cart Summary</p>
              <svg
                className="w-[80px] h-auto mt-[10px] mb-[40px] mr-auto"
                viewBox="0 0 229 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
                  stroke="currentColor"
                  strokeOpacity="0.2"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 1L29.4 21L57.7 1L86.1 21L114.5 1L142.8 21L171.2 1L199.6 21L228 1"
                  stroke="#9D9D9D"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </>
          ) : (
            <>
              <p className="text-xl">Cart Summary</p>
              <svg
                className="w-[80px] h-auto mt-[10px] mb-[40px] mr-auto"
                viewBox="0 0 229 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
                  stroke="currentColor"
                  strokeOpacity="0.2"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 1L29.4 21L57.7 1L86.1 21L114.5 1L142.8 21L171.2 1L199.6 21L228 1"
                  stroke="#9D9D9D"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {cart?.map((item) => (
                <div
                  key={`${item.product.id}-${item.size}`}
                  className="bg-gray-100 flex flex-row p-3 mb-[10px] w-full"
                >
                  <div className="flex flex-col gap-[10px]">
                    <div
                      className="bg-white hover:bg-primary hover:text-white hover:font-bold w-[35px] h-[35px] cursor-pointer flex flex-row items-center justify-center"
                      onClick={() => handleIncreaseQuantity(item.product, item.size)}
                    >
                      +
                    </div>
                    <div
                      className="bg-white hover:bg-primary hover:text-white hover:font-bold w-[35px] h-[35px] cursor-pointer flex flex-row items-center justify-center"
                      onClick={() => handleDecreaseQuantity(item.product.id, item.size)}
                    >
                      -
                    </div>
                  </div>
                  <img
                    src={item.product.image}
                    className="ml-[15px] h-[80px] w-[80px] w-auto object-cover"
                    alt=""
                  />
                  <div className="flex flex-col ml-[20px] justify-center w-[calc(100%-250px)]">
                    <p className="text-lg">{item.product.name}</p>
                    <p className="text-sm text-gray-500 w-[90%]">
                      {item.product.description.length > 90
                        ? item.product.description.substring(0, 97) + "..."
                        : item.product.description}
                    </p>
                  </div>
                  <div className="flex flex-col items-end flex-start w-[120px]">
                    <p className="text-sm bg-white p-2 w-full text-center rounded-full">
                      {item.quantity} &nbsp; &nbsp; * &nbsp; &nbsp; {item.size}
                    </p>
                    <p className="text-sm bg-white p-2 w-full text-center rounded-full mt-auto">₹{item.product.price * item.quantity}</p>
                  </div>
                </div>
              ))}
              <div className="flex flex-row items-center justify-center gap-[20px] mt-[17px] w-full">
                <button
                  className="bg-primary text-white text-md font-semibold mt-1 py-3 px-5 flex-1"
                  onClick={() => navigate('/checkout')}
                >
                  Checkout
                </button>
                <button
                  className="bg-gray-100 text-black text-md font-semibold mt-1 py-3 px-5 flex-1"
                  onClick={() => navigate('/shop')}
                >
                  Continue Shopping
                </button>
              </div>
            </>
          )}
        </div>
        <div className="w-[5%]"></div>
        <div className="w-[40%] flex flex-col p-5 mb-auto">
          <p className="text-xl">Cart Summary</p>
          <svg
            className="w-[80px] h-auto mt-[10px] mb-[40px] mr-auto"
            viewBox="0 0 229 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
              stroke="currentColor"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
              stroke="currentColor"
              strokeOpacity="0.2"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 1L29.4 21L57.7 1L86.1 21L114.5 1L142.8 21L171.2 1L199.6 21L228 1"
              stroke="#9D9D9D"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <p>Cart Value &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; : &nbsp; &nbsp; &nbsp;<strong>₹ {cartValue}</strong></p>
          <p>No. Of Products &nbsp; &nbsp; &nbsp;: &nbsp; &nbsp; &nbsp;<strong>{cart.length} Items</strong></p>

          <p className="bg-yellow-100 p-4 mt-[30px] my-[30px]">
            The items will be delivered to your address within 3-4 working days. The delivery charges
            are <strong>not</strong> included in the cart value. A tracking link will be sent to your
            email and phone once shipped.
          </p>
        </div>
        <div className="w-[2.5%]"></div>
      </div>}

      {cart.length === 0 && <div className='flex flex-col items-center justify-center bg-white p-8 px-5 w-full h-auto mb-[40px]'>
        <p className='text-2xl'>Cart Empty</p>
        
        <svg
          className="w-[80px] h-auto mt-[12px] mb-[40px] mx-auto"
          viewBox="0 0 229 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 1L29.4 21L57.7 1L86.1 21L114.5 1L142.8 21L171.2 1L199.6 21L228 1"
            stroke="#9D9D9D"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <p className='text-center'>There are no Items in the cart. Please add some items and come back. <br /> There are a couple of offers going on !! Add your items and enjoy the taste of indian-ness</p>
        <div className='flex flex-row gap-[20px] mt-[40px]'>
          <button
            className="bg-primary text-white text-md font-semibold mt-1 py-3 px-8"
            onClick={() => navigate('/shop')}
          >
            Continue Shopping
          </button>
          <button
            className="bg-gray-100 text-black text-md mt-1 py-3 px-8"
            onClick={() => navigate('/contact')}
          >
            Contact Us
          </button>
        </div>
      </div>}
        
      <>
        {cart.length !== 0 && <>
          <div className="mt-[60px] text-3xl font-bold flex flex-row gap-[40px] items-center justify-center mr-auto">
            Recommended Products
          </div>

          <svg
            className="w-[100px] h-auto mt-[20px] mb-[40px] mr-auto"
            viewBox="0 0 229 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
              stroke="currentColor"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
              stroke="currentColor"
              strokeOpacity="0.2"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 1L29.4 21L57.7 1L86.1 21L114.5 1L142.8 21L171.2 1L199.6 21L228 1"
              stroke="#9D9D9D"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </>}

        <ProductList products={products} />
      </>

      <div className="h-[50px] w-full"></div>
    </div>
  );
};
